import styles from './menu.module.scss';


export const MenuDivider = () => {
  return (
    <li className={styles.divider} />
  );
}